import Vue from 'vue'
import App from './App.vue'
import VueRouter from 'vue-router'
import axios from 'axios'
import './styles/main.scss'
import {routes} from "./routes"
import store from "./store/store"
//npm install vue-currency-input
import VueCurrencyInput from 'vue-currency-input'
//npm install vue-js-toggle-button --save
import ToggleButton from 'vue-js-toggle-button'
import CookieLaw from 'vue-cookie-law'
import Vuetable from 'vuetable-2'
//npm install vue-meta --save
import Meta from 'vue-meta'
import VueGtag from "vue-gtag";
import { library } from '@fortawesome/fontawesome-svg-core'
import { faRandom, faSearch, faArrowLeft, faChartLine, faCalculator, faChevronLeft, faChevronRight, faRedoAlt, faInfoCircle, faEdit, faTrash, faPlus, faFrown, faMeh, faSmile, faCheck, faTimes, faBars, faShareAlt, faShareSquare, faComments, faAngleLeft, faAngleUp, faAngleDown, faCoins, faTrophy, faClipboardList, faBalanceScale, faHandHoldingUsd, faChartBar, faAngleDoubleLeft, faAngleDoubleRight, faAngleRight, faUsers, faBuilding, faStar, faChartPie, faThumbsDown, faPercentage, faCalendarAlt} from '@fortawesome/free-solid-svg-icons'
import { faInstagram, faLinkedin,faFacebookSquare } from '@fortawesome/free-brands-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import Autocomplete from '@trevoreyre/autocomplete-vue'
import '@trevoreyre/autocomplete-vue/dist/style.css'

library.add(faRandom, faSearch, faArrowLeft, faChartLine, faCalculator, faChevronLeft, faChevronRight, faRedoAlt, faInfoCircle, faEdit, faTrash, faPlus, faFrown, faMeh, faSmile, faCheck, faTimes, faBars, faShareAlt, faShareSquare, faComments, faInstagram, faLinkedin, faFacebookSquare, faAngleLeft, faAngleUp, faAngleDown, faCoins, faTrophy, faClipboardList, faBalanceScale, faHandHoldingUsd, faChartBar, faAngleDoubleLeft, faAngleDoubleRight, faAngleRight, faUsers, faBuilding, faStar, faChartPie, faThumbsDown, faPercentage, faCalendarAlt)
Vue.component('font-awesome-icon', FontAwesomeIcon)
Vue.use(VueCurrencyInput)
Vue.use(ToggleButton)
Vue.use(Meta)
Vue.use(CookieLaw)
Vue.use(Vuetable);
Vue.use(Autocomplete)

Vue.use(VueRouter);
axios.default.baseUrl = '';
Vue.prototype.$http = axios;

Vue.config.productionTip = false

const router = new VueRouter({
  mode: 'history',
  routes
})
Vue.use(VueGtag, {
  config: { id: "UA-180866397-1",
            params: {
              send_page_view: false,
              anonymize_ip: true
          }
  },
  enabled: false,
}, router);

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
